"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
var _taskConfig = require("@/api/taskConfig/taskConfig.js");
var _couponExpand = require("@/api/activity/couponExpand");
var _redbook = _interopRequireDefault(require("@/api/activity/redbook.js"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = (0, _defineProperty2.default)({
  name: 'ExpandAdd',
  emits: ['saved'],
  props: {
    actId: {
      type: Number,
      default: 0
    }
  },
  watch: {
    actId: {
      immediate: true,
      handler: function handler(newId, oldId) {
        console.log('newId', newId, oldId);
        // 避免初始化时的不必要调用
        if (newId && newId != '' && newId != 'null') {
          this.fetchActDetail(newId);
        }
        ;
        console.log('actId', newId);
      }
    }
  },
  data: function data() {
    return {
      typeOptions: [],
      tableData: [],
      searchForm: {
        page: 1,
        limit: 10,
        total: 0
      },
      resPath: process.env.VUE_APP_IMAGE_PATH,
      loading: false,
      // 控制 v-loading 显示隐藏
      dialogVisible: false,
      // 控制任务设置弹窗显示
      totalNum: '',
      form: {
        monthlyBaseLimit: '',
        taskCategory: 3,
        ruleList: [{
          taskType: '',
          monthlyTarget: ''
        }],
        rewardType: 1,
        rewardValue: '',
        // maxFailMonths: '',
        status: 0,
        couponList: [{
          couponId: '',
          quantity: 1
        }]
      },
      rules: {
        monthlyBaseLimit: [{
          required: true,
          message: '请输入数量',
          trigger: 'blur'
        }]
        // maxFailMonths: [{ required: true, message: '请输入月数', trigger: 'blur' }],
      },
      couponOptions1: [],
      couponLoading: false
    };
  },
  mounted: function mounted() {},
  methods: {
    changeTaskCategory: function changeTaskCategory() {
      // 切换任务条件时重置相关字段
      if (this.form.taskCategory == 2) {
        this.form.ruleList = [{
          taskType: '',
          monthlyTarget: ''
        }];
      }
    },
    changeStatus: function changeStatus(id, status) {
      var _this = this;
      var data = {
        id: id,
        status: status
      };
      _redbook.default.changeOfficerTaskStatus(data).then(function (res) {
        if (res.code === 200) {
          _this.$message.success('操作成功');
          _this.fetchList();
        } else {
          _this.$message.error(res.message);
        }
      });
    },
    fetchList: function fetchList() {
      var _this2 = this;
      this.loading = true;
      _redbook.default.getOffterTask(this.searchForm).then(function (res) {
        res.records.forEach(function (item) {
          var date = new Date(item.updateTime);
          var year = date.getFullYear();
          var month = _this2.pad(date.getMonth() + 1);
          var day = _this2.pad(date.getDate());
          var hours = _this2.pad(date.getHours());
          var mins = _this2.pad(date.getMinutes());
          var secs = _this2.pad(date.getSeconds());
          item.updateTime = "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(mins, ":").concat(secs);
        });
        _this2.tableData = res.records || [];
        _this2.searchForm.total = res.total || 0;
      }).finally(function () {
        _this2.loading = false;
      });
    },
    handleReduce: function handleReduce(index, index2) {
      if (index2 == 2) {
        if (this.form.couponList.length > 1) {
          this.form.couponList.splice(index, 1);
        } else {
          this.$message.warning('至少保留一项优惠券组合');
        }
      } else {
        if (this.form.ruleList.length > 1) {
          this.form.ruleList.splice(index, 1);
        } else {
          this.$message.warning('至少保留一项任务');
        }
      }
    },
    handleAdd: function handleAdd(index) {
      if (index == 2) {
        this.form.couponList.push({
          couponId: '',
          quantity: 1
        });
      } else {
        this.form.ruleList.push({
          taskType: '',
          monthlyTarget: ''
        });
      }
    },
    pad: function pad(n) {
      return n.toString().padStart(2, '0');
    },
    // 获取任务详细信息
    editForm: function editForm(id) {
      var _this3 = this;
      var id2 = id;
      // if (id.endsWith('_copy')) {
      //     id2 = id.replace('_copy', '');
      // }

      _redbook.default.getOfficerTaskDetail(id2).then(function (res) {
        if (res.code !== 200) return;
        if (res.data.taskCategory == 2 && res.data.ruleList && res.data.ruleList.length > 0) {
          _this3.totalNum = res.data.ruleList[0].monthlyTarget || '';
        }
        _this3.form = res.data; // 假设返回的数据结构是 { data: {...} }

        if (res.data.rewardType == 2) {
          var promises = res.data.couponList.map(function (item) {
            return (0, _couponExpand.getCouponByThirdId)(item.couponId).then(function (response) {
              response.data.thirdCouponId = Number(response.data.thirdCouponId);
              // 不要赋值 push 的返回值，直接 push 到数组或返回数据由 Promise.all 统一赋值
              _this3.$set(item, 'couponName', response.data.typeName || '');
              return response.data;
            }).catch(function (error) {
              console.error('获取失败:', error);
              return null;
            });
          });
          Promise.all(promises).then(function (results) {
            // 过滤掉失败的 null，然后整体替换 couponOptions1
            _this3.couponOptions1 = results.filter(function (r) {
              return r;
            });
            console.log('couponOptions12', _this3.couponOptions1);
          });
        }
        _this3.dialogVisible = true;
        console.log(" res", res);
      });
    },
    // 页码变化
    handlePageChange: function handlePageChange(newPage) {
      this.searchForm.page = newPage;
      this.fetchList();
    },
    handleSizeChange: function handleSizeChange(newSize) {
      this.searchForm.limit = newSize;
      this.searchForm.page = 1;
      this.fetchList();
    },
    fetchCoupons1: function fetchCoupons1(query) {
      var _this4 = this;
      this.couponLoading = true;
      var params = {
        page: 1,
        limit: 9999,
        typeName: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
      };
      (0, _taskConfig.getBonusTypes)(params).then(function (res) {
        _this4.couponOptions1 = res.records || [];
      }).finally(function () {
        _this4.couponLoading = false;
      });
    },
    handleSubmit: function handleSubmit() {
      var _this5 = this;
      // this.loading = true; // 开始加载
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
          var formData;
          return regeneratorRuntime.wrap(function (_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (valid) {
                  _context.next = 1;
                  break;
                }
                _this5.loading = false; // 停止加载
                return _context.abrupt("return");
              case 1:
                formData = _this5.form;
                if (formData.rewardType != 2) {
                  formData.couponList = null;
                } else {
                  if (Array.isArray(formData.couponList)) {
                    formData.couponList = formData.couponList.map(function (it, idx) {
                      return {
                        couponId: it.couponId,
                        quantity: it.quantity,
                        sort: idx + 1
                      };
                    });
                  }
                }
                if (formData.taskCategory == 2) {
                  formData.ruleList = [{
                    monthlyTarget: _this5.totalNum
                  }];
                }
                console.log('formData', formData);
                _this5.loading = true; // 开始加载

                _redbook.default.addOfficerTask(formData).then(function (res) {
                  if (res.code === 200) {
                    _this5.loading = false; // 停止加载
                    _this5.$message.success('操作成功');
                    _this5.dialogVisible = false;
                    _this5.fetchList();
                  } else {
                    _this5.loading = false; // 停止加载
                    _this5.$message.error(res.message);
                  }
                });
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    addAct: function addAct() {
      // 打开弹窗并重置表单
      this.resetForm();
      this.dialogVisible = true;
    },
    resetForm: function resetForm() {
      var _this6 = this;
      this.form = {
        ruleList: [{
          taskType: '',
          monthlyTarget: ''
        }],
        rewardType: 1,
        rewardValue: '',
        // maxFailMonths: '',
        status: 0,
        couponList: [{
          couponId: '',
          quantity: 1
        }]
      };
      this.$nextTick(function () {
        if (_this6.$refs.formRef) {
          _this6.$refs.formRef.clearValidate();
        }
      });
    },
    getTaskType: function getTaskType() {
      var _this7 = this;
      var data = {
        page: 1,
        limit: 9999
      };
      _redbook.default.getTaskType(data).then(function (res) {
        console.log('res', res);
        if (res.code == 200) {
          _this7.typeOptions = res.records;
        }
      });
    }
  }
}, "mounted", function mounted() {
  this.fetchList();
  this.getTaskType();
});